
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motion-graphics/[...mgCategoryPath]",
      function () {
        return require("private-next-pages/motion-graphics/[...mgCategoryPath]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motion-graphics/[...mgCategoryPath]"])
      });
    }
  